import React from "react";
import Call from "../../../hocs/call";
import {connect} from "react-redux";
import ArtefactList from "../../../components/artefact-list";
import {
  deleteHierarchicalCodelistsHierarchicalCodelist,
  deleteHierarchicalCodelistsSelectedHierarchicalCodelists,
  hideHierarchicalCodelistsHierarchicalCodelistParentsAndChildren,
  readHierarchicalCodelistsHierarchicalCodelistParentsAndChildren,
  readHierarchicalCodelistsListHierarchicalCodelists,
  showHierarchicalCodelistsHierarchicalCodelistClone,
  showHierarchicalCodelistsHierarchicalCodelistDetail,
  showHierarchicalCodelistsHierarchicalCodelistDownload,
  showHierarchicalCodelistsHierarchicalCodelistExport
} from "./actions";

const mapStateToProps = state => ({
  hierarchicalCodelists: state.scenes.metaManager.hierarchicalCodelists.hierarchicalCodelists,
  parentsAndChildren: state.scenes.metaManager.hierarchicalCodelists.parentsAndChildren
});

const mapDispatchToProps = dispatch => ({
  fetchHierarchicalCodelists: () => dispatch(readHierarchicalCodelistsListHierarchicalCodelists()),
  onHierarchicalCodelistShow: hierarchicalCodelistTriplet => dispatch(showHierarchicalCodelistsHierarchicalCodelistDetail(hierarchicalCodelistTriplet)),
  onDelete: hierarchicalCodelistTriplet => dispatch(deleteHierarchicalCodelistsHierarchicalCodelist(hierarchicalCodelistTriplet)),
  onSelectedHierarchicalCodelistsDelete: hierarchicalCodelistTriplets => dispatch(deleteHierarchicalCodelistsSelectedHierarchicalCodelists(hierarchicalCodelistTriplets)),
  fetchParentsAndChildren: (artefactType, artefactTriplet) =>
    dispatch(readHierarchicalCodelistsHierarchicalCodelistParentsAndChildren(artefactType, artefactTriplet)),
  onParentsAndChildrenHide: () => dispatch(hideHierarchicalCodelistsHierarchicalCodelistParentsAndChildren()),
  onCloneShow: artefactTriplet => dispatch(showHierarchicalCodelistsHierarchicalCodelistClone(artefactTriplet)),
  onExportShow: sourceTriplet => dispatch(showHierarchicalCodelistsHierarchicalCodelistExport(sourceTriplet)),
  onDownloadShow: (hierarchicalCodelistTriplets, lang) => dispatch(showHierarchicalCodelistsHierarchicalCodelistDownload(hierarchicalCodelistTriplets, lang))
});

const HierarchicalCodelistsList = ({
                                     hierarchicalCodelists,
                                     fetchHierarchicalCodelists,
                                     onHierarchicalCodelistShow,
                                     onDelete,
                                     onSelectedHierarchicalCodelistsDelete,
                                     onDownloadShow,
                                     parentsAndChildren,
                                     fetchParentsAndChildren,
                                     onParentsAndChildrenHide,
                                     onCloneShow,
                                     onExportShow
                                   }) =>
  <Call cb={fetchHierarchicalCodelists} disabled={hierarchicalCodelists !== null}>
    <ArtefactList
      artefacts={hierarchicalCodelists}
      onDetailShow={onHierarchicalCodelistShow}
      onDownloadShow={onDownloadShow}
      onDelete={onDelete}
      onSelectedItemDelete={onSelectedHierarchicalCodelistsDelete}
      parentsAndChildren={parentsAndChildren}
      fetchParentsAndChildren={triplet => fetchParentsAndChildren("hierarchicalCodelist", triplet)}
      onParentsAndChildrenHide={onParentsAndChildrenHide}
      showImportButton
      onCloneShow={onCloneShow}
      onExportShow={onExportShow}
    />
  </Call>;

export default connect(mapStateToProps, mapDispatchToProps)(HierarchicalCodelistsList);



// WEBPACK FOOTER //
// ./src/scenes/meta-manager/hierarchical-codelists/List.jsx